// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1uITM","errors":"Errors_errors__1QPz1"};